import { noop } from "lodash";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";

import type { SpaceGroupSelectCompassComponentProps } from "./SpaceGroupSelectCompassComponent";
import { SpaceGroupSelectCompassComponent } from "./SpaceGroupSelectCompassComponent";

export interface SpaceGroupSelectCompassProps extends SpaceGroupSelectCompassComponentProps {
  defaultValue?: number;
  name: string;
  onChange?: () => void;
  rules?: Record<string, unknown>;
}

interface ControllerRenderProps {
  field: {
    value: number | null;
    onChange: (value: unknown) => void;
  };
}

export const SpaceGroupSelectCompass = ({
  name,
  rules = {},
  defaultValue,
  onChange = noop,
  ...passThroughProps
}: SpaceGroupSelectCompassProps) => {
  const { control, setValue } = useFormContext();

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }: ControllerRenderProps) => (
        <SpaceGroupSelectCompassComponent
          {...passThroughProps}
          value={field.value}
          onChange={val => {
            field.onChange(val);
            setValue(name, val, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            });
            onChange?.();
          }}
        />
      )}
    />
  );
};

SpaceGroupSelectCompass.displayName = "SpaceGroupSelectCompass";
